import { Flame, HandHeart, Users, BookOpen, Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";

const MINISTRIES = [
  {
    icon: Flame,
    title: "Prayer & Intercession",
    text: "Standing in the gap four days a week. Join us Monday, Tuesday, and Thursday evenings as we pray for our families, our city, and our nation.",
    span: "md:col-span-7",
  },
  {
    icon: BookOpen,
    title: "WED 3for30",
    text: "Our midweek discipleship experience — thirty minutes of the Word, worship, and real-life application, every Wednesday evening.",
    span: "md:col-span-5",
  },
  {
    icon: HandHeart,
    title: "Outreach & Evangelism",
    text: "Reaching the lost in Presidential Hills and beyond through community outreach, service projects, and the simple love of Christ in action.",
    span: "md:col-span-5",
  },
  {
    icon: Users,
    title: "Family & Youth",
    text: "Building the next generation of believers with teaching, mentorship, and a safe place for children and young people to grow in faith.",
    span: "md:col-span-7",
  },
  {
    icon: Sparkles,
    title: "Worship & Arts",
    text: "Leading the house into God's presence through music, song, and creative expression every Sunday morning.",
    span: "md:col-span-12",
  },
];

export default function Ministries() {
  return (
    <section id="ministries" data-testid="ministries-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#4169E1] mb-6">Get Connected</p>
          <h2 className="font-display font-bold uppercase tracking-tighter leading-none text-4xl sm:text-5xl md:text-6xl">
            Ministries
          </h2>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-8">
          {MINISTRIES.map((m, i) => (
            <Reveal key={m.title} delay={(i % 2) * 0.1} className={m.span}>
              <div
                data-testid={`ministry-card-${i}`}
                className="group h-full bg-[#111] border border-white/10 rounded-sm p-10 md:p-12 hover:border-[#4169E1]/40 hover:-translate-y-1 transition-[transform,border-color] duration-500"
              >
                <m.icon className="w-8 h-8 text-[#4169E1] mb-6 transition-transform duration-500 group-hover:scale-110" />
                <h3 className="font-display font-semibold uppercase tracking-tight text-2xl mb-4">{m.title}</h3>
                <p className="text-sm md:text-base text-zinc-400 leading-relaxed">{m.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
